import { makeStyles } from '@mui/styles';

const useSharedStyles = makeStyles(() => ({
  dialogActions: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '10px',
    margin: '10px 0',
    minWidth: '550px',
  },
}));

export default useSharedStyles;
